import {
  ModalType,
  useFeatureFlagContext,
  useModalContext,
} from 'modules/campaigns/editor/context';
import { BUTTON_SIZES, SecondaryButton } from 'ui/button';
import { TimeClock24 } from 'ui/icons';
import { CampaignPopover } from '../../../CampaignPopover';
import { CampaignPermissionCheck } from '../../CampaignPermissionCheck';

export const RescheduleDisplayCampaignAction = () => {
  const { isSuspendSendsEnabled } = useFeatureFlagContext();
  const { openModal } = useModalContext();

  return (
    <CampaignPermissionCheck action={'reschedule'} ChildWrapper={CampaignPopover}>
      <SecondaryButton
        data-test="reschedule-display-button"
        size={BUTTON_SIZES.LARGE}
        onClick={() => openModal(ModalType.DisplayEligibilityCampaign)}
        isDisabled={isSuspendSendsEnabled}
      >
        <TimeClock24 />
        Reschedule
      </SecondaryButton>
    </CampaignPermissionCheck>
  );
};
